import { useEffect, Component } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Categories from "@/components/Categories";
import Catalog from "@/components/Catalog";
import GiftSection from "@/components/GiftSection";
import Companies from "@/components/Companies";
import Events from "@/components/Events";
import Process from "@/components/Process";
import About from "@/components/About";
import Gallery from "@/components/Gallery";
import InstagramSection from "@/components/InstagramSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    render() {
        if (this.state.error) {
            return (
                <div className="min-h-screen flex items-center justify-center bg-cream px-6 text-center">
                    <div>
                        <h1 className="font-display text-3xl text-ink">
                            Magnus Personalizados
                        </h1>
                        <p className="font-body text-sm text-inksoft mt-3">
                            Algo saiu do trilho. Recarregue a página para
                            continuar.
                        </p>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

const Page = () => {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = undefined;
        };
    }, []);

    return (
        <div className="bg-cream text-ink font-body">
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <Categories />
                <Catalog />
                <GiftSection />
                <Companies />
                <Events />
                <Process />
                <About />
                <Gallery />
                <InstagramSection />
                <ContactSection />
            </main>
            <Footer />
            <FloatingWhatsApp />
            <Toaster position="bottom-center" richColors />
        </div>
    );
};

function App() {
    return (
        <ErrorBoundary>
            <Page />
        </ErrorBoundary>
    );
}

export default App;
